import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmApiNeedEmailTfaError } from '@/core/error/transport/customErrors/tmApiNeedEmailTfaError'

export const authNeedTFAEmailConfirmationRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  klass: TmApiNeedEmailTfaError,
}
